import { render } from "./OutsourcedWorksPage.vue?vue&type=template&id=0ee6e0c8&ts=true"
import script from "./OutsourcedWorksPage.vue?vue&type=script&lang=ts"
export * from "./OutsourcedWorksPage.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./OutsourcedWorksPage.vue?vue&type=style&index=0&id=0ee6e0c8&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__